import { useContext } from 'react';
import GeneralContext from '../../../context/GeneralContext';

const ArrowBackLogic = () => {
  const { lan, setGeneralValues } = useContext(GeneralContext);

  return {
    lan,
    setGeneralValues
  };
};

export default ArrowBackLogic;
